import { toast } from 'react-toastify'
import apiService from 'services/api'
import { Tag } from 'models/tags'
import { TaglistCell } from 'components/FbUI/StagePill'
import { MobileAssignModal } from './MobileAssignModal'

interface MobileTagAssignModalProps {
  isOpen: boolean
  onClose: () => void
  contactCompanyId: number
  doorProxyId?: number
  isDoorPage?: boolean
  onSuccess?: () => void
}

export function MobileTagAssignModal({
  isOpen,
  onClose,
  contactCompanyId,
  doorProxyId,
  isDoorPage = false,
  onSuccess,
}: MobileTagAssignModalProps) {
  const api = apiService()
  const { data: tags, refetch: refetchTags } = api.useGetTags('products')

  const handleCreateTag = async (value: string): Promise<Tag | null> => {
    if (value.length > 50) {
      toast.error('Tag length limited to 50 characters.')
      return null
    }
    return await api.postTag({ tag: value }, 'products')
  }

  const apiAction = async (params: any) => {
    const modifiedParams = {
      ...params,
      include_ids: isDoorPage ? [doorProxyId!] : [contactCompanyId],
      exclude_ids: [],
      filter_params: {},
    }
    return api.commonManageTags({
      values: modifiedParams,
      tableType: isDoorPage ? 'restaurants-bars-doors' : 'companies-table',
    })
  }

  const getSortValue = (tag: Tag, sortBy: string): string | number | Date => {
    switch (sortBy) {
      case 'created':
        return new Date(tag.created)
      case 'modified':
        return new Date(tag.modified)
      case 'name':
        return tag.tag.toLowerCase()
      default:
        return tag.tag.toLowerCase()
    }
  }

  return (
    <MobileAssignModal<Tag>
      isOpen={isOpen}
      onClose={onClose}
      title="Assign Tags"
      subtitle="Select tags to apply or remove."
      items={tags || []}
      renderItem={(tag) => <TaglistCell taglist={[tag]} maxBadges={1} />}
      renderCount={(tag) => tag.opp_count ?? 0}
      countHeader="Companies"
      apiAction={apiAction}
      itemListKey="taglist"
      onSuccess={onSuccess}
      refetchFn={refetchTags}
      onCreateNew={handleCreateTag}
      createNewLabel="Create Tags"
      createNewPlaceholder="New tag name"
      getSortValue={getSortValue}
    />
  )
}
